import setAttributes from '../lib/set-attributes';
import { gsap } from '../vendor/gsap';
import { ScrollToPlugin } from '../vendor/gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

// Open Links in New Tab

const newTabFooterLinks = document.querySelectorAll('#menu-footer-info-menu a');

if (newTabFooterLinks.length > 0) {
    newTabFooterLinks.forEach((link) => {
        setAttributes(link, {
            target: '_blank',
            'aria-label': 'Open in New Tab',
            rel: 'noopener nofollow',
        });
    });
}

// Footer Investor Links Accessibility

const footerInvestorMenu = document.querySelector('.footer-container .investor-login');
const footerInvestorMenuItemHasChildren = [...footerInvestorMenu.querySelectorAll('.investor-login-item')];
footerInvestorMenuItemHasChildren.forEach((item) => {
    const link = item.querySelector('.button-container');
    const subMenu = item.querySelector('.sub-menu');

    item.addEventListener('focus', () => {
        setAttributes(link, {
            'aria-expanded': 'true',
        });
        setAttributes(subMenu, {
            'aria-hidden': 'false',
        });
    });
    item.addEventListener('mouseenter', () => {
        setAttributes(link, {
            'aria-expanded': 'true',
        });
        setAttributes(subMenu, {
            'aria-hidden': 'false',
        });
    });
    item.addEventListener('blur', () => {
        setAttributes(link, {
            'aria-expanded': 'false',
        });
        setAttributes(subMenu, {
            'aria-hidden': 'true',
        });
    });
    item.addEventListener('mouseleave', () => {
        setAttributes(link, {
            'aria-expanded': 'false',
        });
        setAttributes(subMenu, {
            'aria-hidden': 'true',
        });
    });
});

// To Top

const headerLogo = document.querySelector('.header .logo');
const toTopBtn = document.querySelector('.back-to-top');
if (toTopBtn) {
    toTopBtn.addEventListener('click', () => {
        gsap.to(window, { duration: 0.5, scrollTo: { y: 0 } });
        setTimeout(() => {
            headerLogo.focus();
        }, 500);
    });
}
